import React from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Gift, Plus, Percent, Star, Award } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./NoBenefit.css";

export default function NoBenefit() {
    const { id } = useParams();
    const { t } = useTranslation();

    return (
        <motion.div
            className="no-benefit-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
        >
            <div className="icon-container">
                <motion.div
                    className="icon-wrapper"
                    initial={{ rotate: 0, scale: 0.8 }}
                    animate={{ rotate: 12, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <Gift className="icon" />
                </motion.div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="text-content"
            >
                <h1 className="title">
                    {t('noBenefitsFound')}
                </h1>
                <p className="description">
                    {t('createFirstBenefit')}
                </p>

                <Link to={`/home/ManageClubs/${id}/benefits-explained`} className="button-link">
                    <button className="no-benefit-submit-button">
                        <Plus className="button-icon" />
                        {t('createNewBenefit')}
                    </button>
                </Link>
            </motion.div>

            <motion.div
                className="features-grid"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
            >
                <div className="feature-card">
                    <div className="feature-icon-wrapper">
                        <Percent className="feature-icon" />
                    </div>
                    <h3 className="feature-title">{t('benefitsAndDiscounts')}</h3>
                    <p className="feature-description">{t('benefitsAndDiscountsDesc')}</p>
                </div>

                <div className="feature-card">
                    <div className="feature-icon-wrapper">
                        <Star className="feature-icon" />
                    </div>
                    <h3 className="feature-title">{t('loyalty')}</h3>
                    <p className="feature-description">{t('loyaltyDesc')}</p>
                </div>

                <div className="feature-card">
                    <div className="feature-icon-wrapper">
                        <Award className="feature-icon" />
                    </div>
                    <h3 className="feature-title">{t('addedValue')}</h3>
                    <p className="feature-description">{t('addedValueDesc')}</p>
                </div>
            </motion.div>
        </motion.div>
    );
}
